import createCachedSelector from "re-reselect";

const emptyArray = [];
const defaultConsent = {
  isLoaded: false
};

const getConsents = (state, partnerId) => {
  const partnerConsentsData = state.entities.offerPartnerConsents[partnerId];
  return partnerConsentsData ? partnerConsentsData.consents : emptyArray;
};
const getConsentData = (state, partnerId) => state.currentOffer.clientConsentData.consents[partnerId] || defaultConsent;

export const getConsentsIsLoaded = createCachedSelector(getConsentData, consents => {
  return consents.isLoaded;
})((_, partnerId) => partnerId);

export const getOfferPartnerConsents = createCachedSelector(getConsentsIsLoaded, getConsents, (isLoaded, consents) => {
  if (!isLoaded) {
    return emptyArray;
  }
  return consents;
})((_, partnerId) => partnerId);
